import React from 'react'

export default ({ className, title }) => (
  <svg width="16px" height="19px" viewBox="0 0 16 19"
    version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"
  >
    <title>{title}</title>
    <g id="7-9" stroke="none" strokeWidth="1"
      fill="none" fillRule="evenodd" strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="RM---adding-highlight-draft" transform="translate(-279.000000, -1612.000000)" stroke="#56565A"
        strokeWidth="0.64"
      >
        <g id="file-uploaded" transform="translate(271.000000, 1607.000000)">
          <g transform="translate(9.000000, 6.000000)">
            <path d="M4.45316337,14.5714286 C3.76486998,14.5714286 2.05450834,14.5714286 0.677921548,14.5714286 C0.303515815,14.5714286 0,14.2877829 0,13.9378883 L0,0.633542722 C0,0.283648095 0.303515815,0 0.677921548,0 L7.17918919,0 C7.359675,-0.000466883952 7.53291023,0.0663429337 7.66051349,0.185629754 L11.3307808,3.61561675 C11.4579245,3.73440095 11.5294118,3.89551813 11.5294118,4.06352972 C11.5287075,5.52902017 11.5281793,5.99459774 11.5278271,6.72734296" id="Path" />
            <path d="M7.41176471,0 L7.41176471,3.36274273 C7.41176471,3.74098947 7.72369929,4.04761905 8.1084901,4.04761905 L11.5294118,4.04761905" id="Path" />
            <g id="Group-5" transform="translate(6.588235, 9.714286)">
              <ellipse id="Oval" cx="3.70588235" cy="3.64285714"
                rx="3.70588235" ry="3.64285714"
              />
              <path d="M5.76470588,2.42857143 L4.03723008,4.68279537 C3.95949126,4.78391406 3.84067302,4.84712152 3.71154002,4.85605195 C3.58240703,4.86498237 3.45565768,4.81875759 3.3641102,4.7293462 L2.47058824,3.85651814" id="Path" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
